<template>
	<div class="cloud-Progress">
		<ul>
			<li v-for="item in tunnelListData" :key="item.id">
				<div class="province-title">
					<p>{{ processVariableName(item.name) }}</p>
					<p><el-progress :percentage="Number(item.num)" :stroke-width="15" color="#58DEFF"></el-progress></p>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>

import { getstatisticsTunnelProgress } from '@/public/api.js'
import { ProgressData } from '../testData/ProgressData'

// 引入路由实例
export default {
	name: 'Progress',
	components: {
	},
	data() {
		return {
			tunnelListData: []
		}
	},
	computed: {

	},
	mounted() {
		this.StatisticsTunnelProgress();
	},
	methods: {
		// 统计隧道进度
		StatisticsTunnelProgress() {
			let that = this;
			getstatisticsTunnelProgress({
				pageNum: 1,
				pageSize: 10
			}).then(res => {
				if (res.data.code == 200) {
					let dataDom = res.data.rows;

					let hostName = window.location.hostname;

					if (hostName == '127.0.0.1' || hostName == '39.100.79.198' || hostName == 'sd.yongsixinxi.com') {
						dataDom = ProgressData()
					}

					dataDom.forEach(item => {
						that.tunnelListData.push({
							name: item.tunnelName,
							num: parseFloat(item.completionRatio).toFixed(0)
						})
					})
				}
			})
		},
		processVariableName(varName) {
			// 利用字符串slice方法，-8表示从倒数第8位开始截取到末尾
			return varName.slice(-8);
		}
	},
	beforeDestroy() {

	}
}
</script>
<style scoped>
.cloud-Progress {
	width: 92%;
	height: 100%;
	text-align: left;
	overflow-y: auto;


	>ul {
		list-style: none;
		margin: 0;
		padding: 0;

		>li {
			width: 100%;
			height: 2.0vh;
			margin-top: 1.5vh;

			>div {
				width: 100%;
				height: 2.0vh;
				margin: 0;
				padding: 0;
			}

			>div>p {
				width: 100%;
				height: 2.0vh;
				margin: 0;
				padding: 0;
				font-size: 0.8rem;
				color: #fff;
				text-align: left;

				&:nth-child(1) {
					width: calc(125 / 1920 * 100vw);
					height: 2.0vh;
					float: left;
					/* 核心属性组合 */
					white-space: nowrap;
					/* 强制文本不换行 */
					overflow: hidden;
					/* 隐藏超出容器的内容 */
					text-overflow: ellipsis;
					/* 超出部分显示省略号 */

				}

				&:nth-child(2) {
					width: calc(200 / 1920 * 100vw);
					height: 2.0vh;
					float: right;
				}
			}
		}
	}

	::v-deep .el-progress__text {
		font-size: 0.8rem !important;
		margin-left: 10px !important;
	}
}
</style>